import { Drawer } from '@mui/material'
import React from 'react'

import { SaveServiceGoldenSignalForm } from 'components/services/create/SaveServiceGoldenSignalForm'
import { ServiceGoldenSignal } from 'types/api/services/golden-signal'

export const SaveServiceGoldenSignalDrawer: React.FC<{
  isOpen: boolean
  onAuthSave: () => void
  onChanged: (statusCheck: ServiceGoldenSignal, isEdit: boolean) => void
  onClose: () => void
  statusCheck?: ServiceGoldenSignal
}> = ({ isOpen, onAuthSave, onChanged, onClose, statusCheck }) => {
  return (
    <Drawer
      anchor="right"
      data-testid="add-edit-team-integration-dialog"
      open={isOpen}
      onClose={onClose}
    >
      <SaveServiceGoldenSignalForm
        goldenSignal={statusCheck}
        onAuthSave={onAuthSave}
        onCanceled={onClose}
        onChanged={(statusCheck, isEdit) => {
          onClose()
          onChanged(statusCheck, isEdit)
        }}
      />
    </Drawer>
  )
}
